import React from "react";
import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import { TableContainer, Table, TableCell, TableHead, TableBody, TableRow, Paper } from "@mui/material";
import MaterialTable from "material-table";
import { defaultTableOptions, tableIcons, textCell, textHeader } from "../../shared/tableHelper";

const BreachesDiscoveredTable = (props) => {
	
	return (
		<Box sx={{width: "100%", margin: "auto"}}>
			{(props.breaches && props.breaches.length > 0)?
				<MaterialTable
					icons={tableIcons}
					columns={[
						{
							title: "Breach",
							field: "name",
							cellStyle: textCell,
							headerStyle: textHeader,
						},
						{
							title: "Date",
							field: "breach_date",
							cellStyle: textCell,
							headerStyle: textHeader,
							render: (breach) => {
								return <Typography>{`${format(breach.date, "MM-yyyy")}`}</Typography>
							}
						},
						{
							title: "Breach Count",
							field: "count",
							cellStyle: textCell,
							headerStyle: textHeader
						},
						{
							title: "Compromised Data",
							field: "compromisedData",
							cellStyle: textCell,
							headerStyle: textHeader,
							render: (breach) => {
								return <React.Fragment>
									{breach.compromisedDatas.map((compromisedData, i) => {
										return (
											<Typography key={`compromisedData${i}`}>
												{compromisedData}
											</Typography>
										);
									})}
								</React.Fragment>
							}
						}
					]}
					data={props.breaches}
					title=""
					options={defaultTableOptions}
				/>
			: <MaterialTable icons={tableIcons} title="" options={defaultTableOptions}/>}	
			
			
			{(props.breaches)?
				<TableContainer component={Paper} sx={{ width: "100%" }}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell sx={{ textAlign: "left" }}>Name</TableCell>
								<TableCell sx={{ textAlign: "left" }}>Date</TableCell>
								<TableCell sx={{ textAlign: "left" }}>Breach Count</TableCell>
								<TableCell sx={{ textAlign: "left" }}>Compromised Data</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{props.breaches.map((breach, index) => {
								return (
									<TableRow key={`breach${index}`}>
										<TableCell sx={{ textAlign: "left" }}>
											<Typography>
												{breach.name}
											</Typography>
										</TableCell>
										<TableCell sx={{ textAlign: "left" }}>
											<Typography>
											{`${format(breach.date, "MM-yyyy")}`}
											</Typography>
										</TableCell>
										<TableCell sx={{ textAlign: "left" }}>
											<Typography>
												{breach.count}
											</Typography>
										</TableCell>
										<TableCell sx={{ textAlign: "left" }}>
											{breach.compromisedDatas.map((compromisedData, i) => {
												return (
													<Typography key={`compromisedData${i}`}>
														{compromisedData}
													</Typography>
												);
											})}
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			:<React.Fragment/>}
		</Box>
	);
}

export default BreachesDiscoveredTable;